import '../onetrust/onetrust';
import { initDataDogRum } from '../datadog/start-datadog';

// run
export const initSLFPage = async () => {
	initDataDogRum();
};
